import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appAOS]',
  exportAs: 'appAOS'
})
export class AOSDirective {
  @Input() delay: number = 0;
  @Input() aosClass: string;

  constructor(public el: ElementRef) {}

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    const elementPosition = this.el.nativeElement.offsetTop;
    const scrollPosition = window.pageYOffset;

    if (scrollPosition + window.innerHeight >= elementPosition) {
      setTimeout(() => {
        this.el.nativeElement.classList.add(this.aosClass);
      }, this.delay);
    }
  }
}
